import { Injectable, inject } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

export const ENCRYPTED_TOKEN_SET_KEY = 'ENCRYPTED_TOKEN_SET';

export enum StorageKey {
  Moves = 'moves',
  Deposits = 'deposits',
}

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storage = inject(Storage);
  private storageReady = false;

  async setItem<T>(key: string, data: T): Promise<void> {
    await this.waitForStorage();
    await this.storage.set(key, data);
  }

  async getItem<T>(key: string): Promise<T> {
    await this.waitForStorage();
    return (await this.storage.get(key)) as T;
  }

  removeItem(key: string): Promise<void> {
    return this.storage.remove(key);
  }

  static movesKey(roomId: string): string {
    return `${StorageKey.Moves}/${roomId}`;
  }

  static depositsKey(depositId: string): string {
    return `${StorageKey.Moves}/${depositId}`;
  }

  // Utility method to ensure storage is ready before attempting to read/write.
  private async waitForStorage() {
    if (!this.storageReady) {
      await this.storage.create();
      this.storageReady = true;
    }
  }
}
